/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\contract.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import {
  CREATE_CONTRACT,
  SET_SECTION_ID,
  INIT_CONTRACT,
  REDIRECT_TO_SECTION
} from '../actions/contract';
import rSection from './section';
import {
  store
} from '../../globals';
import { ADD_SECTION } from '../actions/section';
// Test phase
import Contract from '../../logic/json_to_contract';
import ConditionEvo from '../../logic/condition_evo';
import { caluclateConditionDependecies } from '../actions/load_contract';
import lpApp from '../../app/lp_app';
import writeHistory from '../../logic/history';
// import contract from '../../logic/jsonTestModel';
// import { contract_json } from '../../logic/jsonTestModel1';
// import { contract0 } from '../../logic/jsonTestModel2';
// lets do it


export function updateSectionsIfConditions() {
  let index = 0;
  let indexO = 0;
  // console.log("Wow")
  const lpRealSections = {};
  const lpOutputSections = {};
  Object.keys(lpApp.references.sections).map((jdx) => {
    const idx = lpApp.references.getSection(jdx);

    // if the it's conditional, and if the thing is new
    if (typeof idx.compiledConditions === 'undefined') {
      lpOutputSections[indexO] = idx;
      indexO += 1;
      if (lpApp.ops.two_steps.checkSection(jdx)) return;
      lpRealSections[index] = idx;
      index += 1;
    } else
    if (idx.compiledConditions && idx.compiledConditions.length === 0) {
      lpOutputSections[indexO] = idx;
      indexO += 1;
      if (lpApp.ops.two_steps.checkSection(jdx)) return;
      lpRealSections[index] = idx;
      index += 1;
    } else
    if (idx.compiledConditions.length > 0 && ConditionEvo.initiated === true) {
      if (ConditionEvo.rawCondition(idx.compiledConditions)) {
        // debugger;
        lpOutputSections[indexO] = idx;
        indexO += 1;
        if (lpApp.ops.two_steps.checkSection(jdx)) return;
        lpRealSections[index] = idx;
        index += 1;
      }
      window.nbr_forced += 1;
    }
  });
  lpApp.indexes.updateRealSections(lpRealSections);
  lpApp.indexes.real_sections.updateOutputSections(lpOutputSections);
}
export function ccontract(state = {
  name: '',
  version: 0,
  this_section: 0,
  currentSection: 0,
  section: {},
  total_sections: 0,
  sections: [],
  client_type: '',
  pro_condition: [],
  fullWidth: false,
  reprise_wizard: false,
  reprise_link: '#',
  comeFrom: '',
}, action) {
  switch (action.type) {
    // LegalTon: here we can add any additionnal feature in the contract.
    case CREATE_CONTRACT: {
      const cont = new Contract(action.contract); // after will be sent by action
      // directly
      // window.lpVarRefs = c.variables;
      lpApp.references.addVariablesRefernce(cont.variables);
      // window.lpOptRefs = c.options;
      lpApp.references.addOptionsReference(cont.options);
      lpApp.references.addSectionsReference(action.contract.contract_architecture.sections);

      caluclateConditionDependecies();

      // Updating sections conditions after initiating ConditionsEvo
      updateSectionsIfConditions();
      lpApp.indexes.updateRoots(lpApp.references.sections);
      return {
        ...state,
        name: cont.name,
        version: cont.contract_version,
        is_two_steps: action.contract.contract_architecture.is_two_steps,
        total_sections: cont.total_sections,
        currentSection: 0,
        sections: lpApp.indexes.real_sections.sections,
        client_type: action.contract.contract_architecture.params ? action.contract.contract_architecture.params.proIdnType : 'pro',
        pro_condition: action.contract.contract_architecture.pro,
        disable_auto_default: action.contract.contract_architecture.params ? action.contract.contract_architecture.params.disableAutoDefault : false,
      };
    }
    case INIT_CONTRACT:
      return state;
    case SET_SECTION_ID: {
      updateSectionsIfConditions();
      let sId = action.id;
      const isaNav = action.isaNav;
      if (action.id > Object.keys(lpApp.indexes.real_sections)) sId = 1;
      // get into the section, and try to feed it with options
      return {
        ...state,
        currentSection: (sId > 0) ? sId : 0,
        section: rSection({}, {
          type: ADD_SECTION,
          section: lpApp.indexes.real_sections.getSection(sId < 0 ? 0 : sId),
          sId,
          isaNav
        }),
        sections: lpApp.indexes.real_sections.sections,
      };
    }
    case REDIRECT_TO_SECTION: {
      let section = action.section;
      const {
        s_id
      } = action;
      let history_mutex = lpApp.mutex.checkMutex("history")
      const { pathname } = window.location;
      let result = {...state,
        comeFrom: pathname.split('/')[3]
      };
      if (store.getState().document_state.state === 'continue') {
        if (history_mutex) {
          writeHistory('normal', true, s_id, store.getState().document_state.unique); // set route id as article number
          // writeHistory('normal', true, section.id - 1, store.getState().document_state.unique);
        } else {
          lpApp.mutex.setMutex("history", true)
        }
      } else {
        if (history_mutex) {
          writeHistory('normal', false, s_id, "");
        } else
          lpApp.mutex.setMutex("history", true)
      }
      return result;
    }
    case 'UPDATE_SECTIONS_C':
      updateSectionsIfConditions();
      return {
        ...state,
        sections: lpApp.indexes.real_sections.sections,
      };
    case 'SET_FULL_WIDTH':
      return {
        ...state,
        fullWidth: action.val,
      };
    case 'REPRISE_WIZARD':
      return {
        ...state,
        reprise_wizard: action.val,
      };
    case 'REPRISE_LINK':
      return {
        ...state,
        reprise_link: action.val,
      };
    default:
      return state;
  }
}

window.uncover_ = updateSectionsIfConditions;



// WEBPACK FOOTER //
// ./src/redux/reducers/contract.js